export default {"src":"/_next/static/media/c-tel-icon.3d761bf4.svg","height":40,"width":40};